module.exports = __webpack_public_path__ + "static/media/Utrecht.9aadedcb.jpg";